import { PerformanceEvaluationStatusEnum } from '@/types/schema';

import { QuestionEvaluationEnum, QuizField } from '../types';

export const getQuestionEvaluation: QuizField['getQuestionEvaluation'] = (performance) => ({
  evaluation:
    performance.evaluationStatus === PerformanceEvaluationStatusEnum.Correct
      ? QuestionEvaluationEnum.Correct
      : QuestionEvaluationEnum.InCorrect,
});
